export default __webpack_public_path__ + "static/dashboard-1364265c6084d0d6ff4d991ec02d8703.svg";